import type { Row } from '../CustomerComms/liveModel';

export type LuxParameter = {
  id: string;
  label: string;
  defaultValue: string;
  options: Array<string>;
  panels: Array<string>;
};
export type LinkedSelection = { panel: string; dimensions: Array<string>; values: Array<string> };
/** JSON avoids collisions between dimension values containing separators. Raw split columns remain available for CSV. */
export function crosstabRow(row: Row, dimensions: Array<string>): Row {
  const values = [String(row.split ?? 'All'), String(row.split_2 ?? 'All'), String(row.split_3 ?? 'All')];
  const active = dimensions.flatMap((dimension, i) => (dimension === 'All' ? [] : [[dimension, values[i]]]));
  return {
    ...row,
    split_primary: row.split,
    split: active.length > 1 ? JSON.stringify(active) : (values[dimensions.findIndex((d) => d !== 'All')] ?? 'All'),
  };
}
export function linkedSelection(panel: string, dimensions: Array<string>, values: Array<unknown>): LinkedSelection {
  const entries = dimensions.flatMap((dimension, i) =>
    dimension && dimension !== 'All' ? [[dimension, String(values[i] ?? 'Unknown')]] : [],
  );
  return { panel, dimensions: entries.map(([key]) => key), values: entries.map(([, value]) => value) };
}
/** Selecting the same mark again clears only the generated action, leaving manual filters intact. */
export function toggleLinkedSelection(current: string, next: LinkedSelection): string {
  const encoded = JSON.stringify(next);
  return current === encoded || !next.dimensions.length ? '{}' : encoded;
}

/** The workbook's two URL actions, using exact source destinations and escaped record keys. */
export function sourceRecordLink(dimension: string, value: unknown): string | undefined {
  if (value == null || value === 'Unknown') return undefined;
  const section = dimension === 'customer_bk' ? 'users' : dimension === 'order_bk' ? 'purchases' : undefined;
  return section ? `https://admin.luxuryescapes.com/${section}/${encodeURIComponent(String(value))}` : undefined;
}

export function breakdownSelection(dimension: string, values: Array<string>): string {
  return dimension === 'All' || !values.length
    ? '{}'
    : JSON.stringify({ panel: 'opportunities', dimensions: [dimension], values: [values] });
}
